<div class="content-area">
  <h3>
    Privacy Policy for the ArtPromenade app and Art-promenade.net family of websites
  </h3>

  <p>This privacy policy was last modified on 4/20/2020
  </p>

  <p>
    Sumner Internet Marketing Emvironments Inc (SIME Corp Inc) operates http://www.PlayAnAlbum.com (the "Site") and the associated iPhone/iPad app PlayAnAlbum (the "App"). This page informs you of our policies regarding the collection , use and disclosure of Personal Information we receive from users of the Site or the App.
  </p>

  <p>
    We use your personal information only for providing and improving the Site and the App. By using the Site or the App you agree to the collection and use of this information in accordance with this policy.
  </p>

  <H3>
    Information Collection and Use
  </H3>

  <p>
    While using our Site or App, we may ask you to provide us with certian personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name("Personal Information").
  </p>

  <H3>
    Log Data
  </H3>

  <p>
    Like many Site and App operators, we collect information that your browser sends whenever you visit our site or that our App sends on certian actions ("Log Data").
      This Log Data may include information such as your devices Internet Protocol ("IP") address, browser or device Type, browser or device version, the pages of the Site you visit, the time and date of your visit, the time spent on those pages and other statistics.
  </p>
</div>
